import React from "react";

function About() {
  return (
    <section className="bg-gray-900 text-gray-100 py-20 min-h-screen" id="about">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold mb-8 text-center" style={{ color: "rgb(92, 225, 230)" }}>About Me</h2>
        <div className="mt-10 text-lg md:mt-12 md:text-xl mx-auto max-w-2xl">
          <p className="text-white text-lg max-w-2xl mx-auto text-center">
            Hello, I’m a software developer! I can help you build a product,
            feature, or website.
          </p>
          <p className="text-white mt-4 text-lg max-w-2xl mx-auto text-center">
            If you're interested in learning more about my experience and
            skills, please check out my resume below.
          </p>
          <div className="mt-10 mt-10 flex justify-start">
            <a
              href="https://drive.google.com/file/d/1rxIYfYyhaoz7ZuZJ0QA7T43SAtzbEhKn/view?usp=sharing"
             target="_blank"
              rel="noreferrer"
              className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-full transition-colors duration-300 shadow-md"
            >
              View my resume
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
